import { type PublicReview } from "@/lib/api";
import { isEnglishLocale } from "@/lib/market";

/**
 * US reviews first for a US visitor.
 *
 * The list is newest-first for everyone, which was the whole ordering while every review was Dutch.
 * It no longer is: an American reading "Chris from Norman, OK" about a 1953 Chevy trusts it in a way
 * he does not trust a translated note about a Messerschmitt, so on /en the reviews written in
 * English lead and the translated ones follow. The sort is stable, so recency survives inside both
 * groups, and nothing is hidden — the Dutch reviews still count in the average and still render.
 */
export function originFirst(reviews: PublicReview[], locale: string): PublicReview[] {
  if (!isEnglishLocale(locale)) return reviews;
  return [...reviews].sort(
    (a, b) => Number(b.originalLanguage === "en") - Number(a.originalLanguage === "en"),
  );
}

/**
 * The place in a byline. US customers get the state ("Peachtree City, GA"), because an American town
 * name on its own does not read as American.
 */
export function bylineCity(review: PublicReview, fallback: string): string {
  const city = review.city?.trim();
  if (!city) return fallback;
  const state = review.state?.trim();
  return state ? `${city}, ${state}` : city;
}
